import { useCallback, useEffect } from "react";
import { useChargesContext } from "../context/ChargesContext";
import {
  fetchAllParaplanningCatalogs,
  fetchAllVersionBatches,
  fetchParaplanningBaseDoc,
  fetchVersionBatchById,
  buildCatalogsFromVersionBatch,
  buildNotesByCatalogFromVersionBatch,
  seedParaplanningStructure,
} from "../services/chargesService";

export const useCharges = (user) => {
  const { state, dispatch } = useChargesContext();

  const refreshCatalogs = useCallback(async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      dispatch({ type: "SET_ERROR", payload: "" });

      try {
        await seedParaplanningStructure(user);
      } catch (seedError) {
        console.error("Seed skipped or failed:", seedError);
      }

      const baseDoc = await fetchParaplanningBaseDoc();

      dispatch({
        type: "SET_CURRENT_VERSION_ID",
        payload: baseDoc?.currentVersionId || "",
      });

      let catalogs = [];
      let notesByCatalog = {};

      if (baseDoc?.currentVersionId) {
        const currentVersionBatch = await fetchVersionBatchById(
          baseDoc.currentVersionId,
        );

        if (currentVersionBatch) {
          catalogs = buildCatalogsFromVersionBatch(currentVersionBatch);
          notesByCatalog =
            buildNotesByCatalogFromVersionBatch(currentVersionBatch);
        }
      }

      if (!catalogs.length) {
        catalogs = await fetchAllParaplanningCatalogs();
      }

      dispatch({ type: "SET_CATALOGS", payload: catalogs });
      dispatch({ type: "SET_NOTES_BY_CATALOG", payload: notesByCatalog });

      const batches = await fetchAllVersionBatches();
      dispatch({ type: "SET_VERSION_BATCHES", payload: batches });
    } catch (error) {
      console.error("Failed to load charges:", error);
      dispatch({
        type: "SET_ERROR",
        payload: error?.message || "Failed to load charges.",
      });
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  }, [dispatch, user]);

  useEffect(() => {
    refreshCatalogs();
  }, [refreshCatalogs]);

  return {
    ...state,
    refreshCatalogs,
  };
};
